import React from "react"
import Preview from "views/Admin/TslNewsletter/Preview"

const TslNewsletterPreview = () => <Preview />

export default TslNewsletterPreview
